// extracted by mini-css-extract-plugin
module.exports = {"dpuDetailG":"G_dpuDetailG__j8gB_"};